import React, { FC } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

interface SuperAdminGuardProps {
  children: React.ReactNode;
}

const SuperAdminGuard: FC<SuperAdminGuardProps> = ({ children }) => {
  const { user } = useAuth();

  // If user is not a super admin, redirect to admin dashboard
  if (!user?.isSuperAdmin) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
};

export default SuperAdminGuard;
